import { Outlet, useNavigate, useLocation } from 'react-router-dom'
import { Box, Tabs, Tab, Typography, Paper, useTheme } from '@mui/material'
import { PermissionGuard } from '../../components/shared/PermissionGuard'

const SETTINGS_TABS = [
  { label: 'System', path: '/settings/system' },
  { label: 'Objects', path: '/settings/objects' },
  { label: 'Key Users', path: '/settings/users' },
  { label: 'Roles', path: '/settings/roles' },
  { label: 'API Tokens', path: '/settings/api-tokens' },
  { label: 'Mashups', path: '/settings/mashups' },
  { label: 'Custom Actions', path: '/settings/custom-actions' },
  { label: 'Data Workbench', path: '/settings/data-workbench' },
  { label: 'Deleted Data', path: '/settings/deleted-data' },
  { label: 'Login Logs', path: '/settings/login-logs' },
  { label: 'Action Logs', path: '/settings/action-logs' },
  { label: 'Attachments', path: '/settings/attachments' },
]

export function SettingsLayout() {
  const navigate = useNavigate()
  const location = useLocation()
  const theme = useTheme()

  const currentTab = SETTINGS_TABS.findIndex((tab) => location.pathname.startsWith(tab.path))

  return (
    <PermissionGuard required="admin">
      <Box sx={{ height: '100%', overflow: 'auto' }}>
        <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>Settings</Typography>
        <Paper
          variant="outlined"
          sx={{
            mb: 2,
            borderRadius: 2,
            bgcolor: 'background.paper',
            borderColor: 'divider',
            overflow: 'hidden',
          }}
        >
          <Tabs
            value={currentTab >= 0 ? currentTab : 0}
            onChange={(_, v) => navigate(SETTINGS_TABS[v].path)}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              bgcolor: 'background.paper',
              px: 1,
              py: 1,
              alignItems: 'center',
              '& .MuiTab-root': {
                borderRadius: 1,
                mx: 0.5,
                minHeight: 'auto',
                minWidth: 'auto',
                padding: '2px 8px',
                bgcolor: theme.palette.tab.unselected,
                transition: 'all 0.2s ease-in-out',
                '&.Mui-selected': {
                  bgcolor: 'primary.main',
                  color: 'primary.contrastText',
                  fontWeight: 600,
                  '&:hover': {
                    bgcolor: 'primary.dark',
                  },
                },
                '&:hover': {
                  bgcolor: 'action.hover',
                },
              },
              '& .MuiTabs-indicator': {
                display: 'none',
              },
            }}
          >
            {SETTINGS_TABS.map((tab) => (
              <Tab key={tab.path} label={tab.label} />
            ))}
          </Tabs>
        </Paper>
        <Outlet />
      </Box>
    </PermissionGuard>
  )
}
